import Particles from 'react-particles-js';

import React from 'react';

const AnimatedBackground = () => {
  return (
    <Particles
      params={{
        particles: {
          number: {
            value: 100,
            density: {
              enable: true,
              value_area: 1500,
            },
          },
        },

        interactivity: {
          events: {
            onHover: {
              enable: true,
              mode: 'repulse',
            },
          },
        },
      }}
      style={{
        position: 'absolute',
        width: `100%`,
        height: `100%`,
      }}
    />
  );
};

export default AnimatedBackground;
